import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_SINGLE_RSVP_EVENT_INFORMATION,
  GET_SINGLE_RSVP_EVENT_PENDING,
  GET_SINGLE_RSVP_EVENT_RSVP,
  GET_SINGLE_RSVP_EVENT_TICKET,
  GET_SINGLE_RSVP_EVENT_HISTORY,
  GET_SINGLE_RSVP_EVENT_ALL,
} from "../../types";
import Alert from "react-s-alert";
import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

/***************************************
 * @DESC - ADD RSVP EVENTS ACTION
 *****************************************/
export const add_rsvp_events =
  (formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_rsvp_events = await axios.post(
        `${serverApi}/event-handler?vendor=true`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_rsvp_events.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        if (add_rsvp_events.data.code === 403) {
          Alert.error(`<h4>${add_rsvp_events.data.message}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else {
          formData.payment_pending = true;
          onSuccess(formData, add_rsvp_events.data._id);
        }
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

/*****************************************************
 * @DESC - GET SINGLE RSVP EVENTS INFORMATION ACTION
 *****************************************************/
export const get_single_rsvp_event_information =
  (eventId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_single_rsvp_event_info = await axios.get(
        `${serverApi}/events/${eventId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_single_rsvp_event_info.status === 200) {
        dispatch({
          type: GET_SINGLE_RSVP_EVENT_INFORMATION,
          payload: get_single_rsvp_event_info.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - FETCH SINGLE RSVP PENDING EVENTS ACTION
 *****************************************/
export const fetch_single_event_pending_data_information =
  (formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let fetch_single_event_pending_information = await axios.get(
        `${serverApi}/event-handler?vendor_id=${formData.vendor_id}&event_id=${formData.event_id}&event_status=PENDING`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (fetch_single_event_pending_information.status === 200) {
        dispatch({
          type: GET_SINGLE_RSVP_EVENT_PENDING,
          payload: fetch_single_event_pending_information.data,
        });
        dispatch(fetch_single_event_rsvp_data_information(formData, token));
        dispatch(fetch_single_event_ticket_data_information(formData, token));
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

/***************************************
 * @DESC - FETCH SINGLE RSVP EVENTS ACTION
 *****************************************/
export const fetch_single_event_rsvp_data_information =
  (formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let fetch_single_event_rsvp_information = await axios.get(
        `${serverApi}/event-handler?vendor_id=${formData.vendor_id}&event_id=${formData.event_id}&event_status=RSVP`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (fetch_single_event_rsvp_information.status === 200) {
        dispatch({
          type: GET_SINGLE_RSVP_EVENT_RSVP,
          payload: fetch_single_event_rsvp_information.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

/***************************************
 * @DESC - FETCH SINGLE RSVP TICKET EVENTS ACTION
 *****************************************/
export const fetch_single_event_ticket_data_information =
  (formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let fetch_single_event_ticket_information = await axios.get(
        `${serverApi}/event-handler?vendor_id=${formData.vendor_id}&event_id=${formData.event_id}&event_status=TICKET_BOOKED`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (fetch_single_event_ticket_information.status === 200) {
        dispatch({
          type: GET_SINGLE_RSVP_EVENT_TICKET,
          payload: fetch_single_event_ticket_information.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

/***************************************
 * @DESC - FETCH SINGLE RSVP HISTORY EVENTS ACTION
 *****************************************/
export const fetch_single_event_history_data_information =
  (formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let fetch_single_event_history_information = await axios.get(
        `${serverApi}/event-handler?vendor_id=${formData.vendor_id}&event_id=${formData.event_id}&event_status=HISTORY`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (fetch_single_event_history_information.status === 200) {
        dispatch({
          type: GET_SINGLE_RSVP_EVENT_HISTORY,
          payload: fetch_single_event_history_information.data,
        });
        dispatch(
          fetch_single_event_pending_data_information(
            formData,
            token,
            onSuccess,
            onError
          )
        );
        dispatch(
          fetch_single_event_rsvp_data_information(
            formData,
            token,
            onSuccess,
            onError
          )
        );
        dispatch(
          fetch_single_event_ticket_data_information(
            formData,
            token,
            onSuccess,
            onError
          )
        );
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

/***************************************
 * @DESC - FETCH SINGLE RSVP ALL EVENTS ACTION
 *****************************************/
export const fetch_single_event_all_data_information =
  (formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let fetch_single_event_all_information = await axios.get(
        `${serverApi}/event-handler?vendor_id=${formData.vendor_id}&event_id=${formData.event_id}&event_status=`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (fetch_single_event_all_information.status === 200) {
        dispatch({
          type: GET_SINGLE_RSVP_EVENT_ALL,
          payload: fetch_single_event_all_information.data,
        });
        dispatch(
          fetch_single_event_pending_data_information(
            formData,
            token,
            onSuccess,
            onError
          )
        );
        dispatch(
          fetch_single_event_rsvp_data_information(
            formData,
            token,
            onSuccess,
            onError
          )
        );
        dispatch(
          fetch_single_event_ticket_data_information(
            formData,
            token,
            onSuccess,
            onError
          )
        );
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

/***************************************
 * @DESC - REJECTING RSVP EVENT REQUEST ACTION
 *****************************************/
export const rejecting_rsvp_event_request =
  (formData, eventId, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let rejecting_rsvp_event_request = await axios.patch(
        `${serverApi}/event-handler/${eventId}?event_status=true`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (rejecting_rsvp_event_request.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>Event Request Rejected Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        //   dispatch(get_offers_details(token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

export const rejectingExpRequest =
  (formData, expId, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let rejecting = await axios.patch(
        `${serverApi}/expRequest/${expId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          }
        }
      );
      if (rejecting.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>Experience Request Rejected Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      Alert.error(`<h4>${err?.response?.data?.message || 'Something went wrong, try again later'}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      // onError();
    }
  };

/**********************************************************
 * @DESC - COMPLETED ALL RSVP SEATING EVENT REQUEST ACTION
 **********************************************************/
export const rsvp_marked_all_seated_to_completed_event_request =
  (eventId, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let marked_all_seated_to_completed_event = await axios.patch(
        `${serverApi}/event-handler/${eventId}?markComplete=true`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (marked_all_seated_to_completed_event.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>All Seated Records Completed Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        //   dispatch(get_offers_details(token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

/**********************************************************
 * @DESC - Vendor assigning a table to the event request ACTION
 **********************************************************/
export const rsvp_assign_table_event_request =
  (formData, waitTimeData, eventId, token, onSuccess, onError, skip) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let assign_table_event_request = await axios.patch(
          `${serverApi}/event-handler/${eventId}`,
          waitTimeData,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );
        if (assign_table_event_request.status === 200) {
          dispatch({ type: CLEAR_LOADER });
          if (
            assign_table_event_request.data.event_status === "SEATED" &&
            assign_table_event_request.data.event_type === "TICKET_BOOKED"
          ) {
            dispatch(
              fetch_single_event_ticket_data_information(
                formData,
                token,
                onSuccess,
                onError
              )
            );
            if (!skip) {
              Alert.success("<h4>Table Assign Successfully</h4>", {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            } else if (skip) {
              Alert.success("<h4>Records updated successfully</h4>", {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            }
          } else if (
            assign_table_event_request.data.event_status === "SEATED" &&
            assign_table_event_request.data.event_type === "RSVP"
          ) {
            dispatch(
              fetch_single_event_rsvp_data_information(
                formData,
                token,
                onSuccess,
                onError
              )
            );
            if (!skip) {
              Alert.success("<h4>Table Assign Successfully</h4>", {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            } else if (skip) {
              Alert.success("<h4>Records updated successfully</h4>", {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            }
          } else if (
            assign_table_event_request.data.event_status === "NOTSEATED" &&
            assign_table_event_request.data.event_type === "TICKET_BOOKED"
          ) {
            dispatch(
              fetch_single_event_ticket_data_information(
                formData,
                token,
                onSuccess,
                onError
              )
            );
          } else if (
            assign_table_event_request.data.event_status === "NOTSEATED" &&
            assign_table_event_request.data.event_type === "RSVP"
          ) {
            dispatch(
              fetch_single_event_rsvp_data_information(
                formData,
                token,
                onSuccess,
                onError
              )
            );
          }
          // dispatch(get_offers_details(token));
          onSuccess();
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        // onError();
      }
    };
/**********************************************************
 * @DESC - Vendor marked the request as completed ACTION
 **********************************************************/
export const rsvp_marked_completed_event_request =
  (formData, eventId, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let marked_completed_event_request = await axios.patch(
        `${serverApi}/event-handler/${eventId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (marked_completed_event_request.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>Records Completed Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        //   dispatch(get_offers_details(token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

/**********************************************************
 * @DESC - Vendor adding a wait time for a event request ACTION
 **********************************************************/
export const rsvp_added_waittime_event_request =
  (formData, waitTimeData, eventId, token, onSuccess, onError) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let added_waittime_event_request = await axios.patch(
          `${serverApi}/event-handler/${eventId}`,
          waitTimeData,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );
        if (added_waittime_event_request.status === 200) {
          dispatch({ type: CLEAR_LOADER });
          if (added_waittime_event_request.data.event_status === "PENDING") {
            dispatch(
              fetch_single_event_pending_data_information(
                formData,
                token,
                onSuccess,
                onError
              )
            );
          } else if (
            added_waittime_event_request.data.event_status === "NOTSEATED" &&
            added_waittime_event_request.data.event_status === "SEATED" &&
            added_waittime_event_request.data.event_type === "TICKET_BOOKED"
          ) {
            dispatch(
              fetch_single_event_ticket_data_information(
                formData,
                token,
                onSuccess,
                onError
              )
            );
          } else if (
            added_waittime_event_request.data.event_status === "NOTSEATED" &&
            added_waittime_event_request.data.event_status === "SEATED" &&
            added_waittime_event_request.data.event_type === "RSVP"
          ) {
            dispatch(
              fetch_single_event_rsvp_data_information(
                formData,
                token,
                onSuccess,
                onError
              )
            );
          }
          onSuccess();
          //   dispatch(get_offers_details(token));
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        // onError();
      }
    };

/**********************************************************
 * @DESC - Vendor edit api for event request ACTION
 **********************************************************/
export const rsvp_edit_perticular_event_request =
  (formData, eventId, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let added_waittime_event_request = await axios.patch(
        `${serverApi}/event-handler/${eventId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(added_waittime_event_request);
      if (added_waittime_event_request.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        // Alert.success("<h4>Event Request Edited Successfully</h4>", {
        //   position: "top-right",
        //   effect: "bouncyflip",
        //   beep: true,
        //   html: true,
        //   timeout: 3000,
        //   offset: 35,
        // });
        onSuccess();
        //   dispatch(get_offers_details(token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      // onError();
    }
  };

export const requestExpAccept =
  (formData, eventId, token, onSuccess, onError) => async (dispatch) => {
    try {
      let added_waittime_event_request = await axios.patch(
        `${serverApi}/expRequest/${eventId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (added_waittime_event_request.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
      }
    } catch (err) {
      Alert.error(`<h4>${err?.response?.data?.message || 'Something went wrong, try again later'}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      // onError();
    }
  };

/**********************************************************
 * @DESC - Vendor Accept event request ACTION
 **********************************************************/
export const rsvp_accept_event_request =
  (formData, waitTimeData, eventId, token, onSuccess, onError) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        let accept_event_request = await axios.patch(
          `${serverApi}/event-handler/${eventId}`,
          waitTimeData,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );
        if (accept_event_request.status === 200) {
          dispatch({ type: CLEAR_LOADER });
          Alert.success(`<h4>Request Accepted Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
          if (accept_event_request.data.event_status === "NOTSEATED") {
            dispatch(
              fetch_single_event_pending_data_information(
                formData,
                token,
                onSuccess,
                onError
              )
            );
          }
          onSuccess();
          //   dispatch(get_offers_details(token));
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        // onError();
      }
    };
